import { useApiPost } from 'mf_core/query';
import { useMutation } from '@tanstack/react-query';

export function useAddLineItems() {
  const apiPost = useApiPost();

  return useMutation({
    mutationFn: async (body: AddLineItems) => {
      const data = await apiPost('/quote-exp/v1/quote-lines', body);
      return data;
    },
  });
}

export interface QuoteResponse {
  serviceresponses: {
    createquoteresponse: {
      quoteguid: string;
      quotenumber: string;
      quoteurl: string;
      status: string;
      statusreason: string;
    };
    responsepreamble: {
      responsemessage: string;
      responsestatus: string;
      statuscode: string;
    };
  };
}

export interface QuoteLinesItems {
  duplicateselected: boolean;
  ecPrice?: number;
  lineId: string;
  margin?: number;
  markUp?: string;
  markUpUnit?: string;
  quantity: string;
  sequenceNumber: any;
  skuvpn: string;
  vendorNumber: string;
  vpn: string;
}

export interface CoTermLine {
  SubscriptionID?: number;
  alignmentType: string;
  cotermSubscriptionId?: string;
  endDate: string;
  lineId: string;
  originalEndDate?: string;
  startDate: string;
}

export interface ResetExpirationLine {
  endDate: string;
  lineId: string;
  startDate: string;
}

export interface QtyUpdateLine {
  duplicateselected: boolean;
  ecPrice: number;
  lineId: string;
  margin: number;
  quantity: string;
  sequenceNumber: number;
  skuvpn: string;
  vendorNumber: string;
  vpn: string;
}

export enum AddLineAction {
  Addtoquote = 'Addtoquote',
  ApplyMarkupForEntireQuote = 'ApplyMarkupForEntireQuote',
  Delete = 'Delete',
  ResetCoTermEndDate = 'ResetCoTermEndDate',
  ResetCoTermStartDate = 'ResetCoTermStartDate',
  UpdateCoTermStartDate = 'UpdateCoTermStartDate',
  UpdateCoTermSubscription = 'UpdateCoTermSubscription',
  Updatequantity = 'Updatequantity',
}

export interface AddLineItems {
  action: AddLineAction;
  attributeName: string;
  attributeValue: string;
  branchNumber: string;
  discount: string;
  endUserInformation?: any;
  entire_markUp: string;
  entire_markUpUnit: string;
  isChangeTax: boolean;
  isEUEnabled: string;
  lineProfitSeleced: string;
  profitValue: string;
  quoteguid: string;
  quotelinesitems: (
    | QuoteLinesItems
    | SubscriptionOptionLine
    | CoTermLine
    | ResetExpirationLine
  )[];
  quotenumber: string;
  shipping: string;
  tax: string;
}

export interface RecurringTiers {
  code: string;
  lowerLimit: number;
  msrp: string;
  price: string;
}

export interface SubscriptionOptionLine {
  billingPeriods?: any;
  duplicateselected?: boolean;
  fees?: any;
  finSystemProfile?: string;
  harmonizedCode?: string | number | null;
  imageurl?: string;
  isCloudProduct?: boolean;
  lineId?: string | null;
  longdescription?: string;
  markUp?: any;
  markUpUnit?: any;
  planApsid?: string;
  planId?: string;
  planName?: string;
  pricingSource?: string;
  quantity?: string | number;
  recurringPriceModel?: string;
  recurringTiers?: RecurringTiers[] | null;
  remainingQuantity?: number | null;
  resourceApsId?: string;
  resourceId?: string;
  serviceTemplateID?: string;
  shortDescription?: string;
  skuvpn?: string;
  subscriptionPeriods?: any;
  units?: any;
  vendorNumber?: string | number | null;
  vpn?: string;
}
